module.exports = __webpack_public_path__ + "img/gsjd.6bcde178.svg";